import { useSelector } from 'react-redux';

const usePackages = () => useSelector(state => state.packagesReducer.packages);
const usePackage = () => useSelector(state => state.packagesReducer.package);

export { usePackages, usePackage };
